import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("C:/Users/PC/Desktop/work/amin/selectalent/selectalent-front/layouts/default.vue").then(m => m.default || m))
}